import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { style: {"width":"100%","display":"flex","justify-content":"space-between"} }
const _hoisted_5 = { style: {"width":"80%"} }
const _hoisted_6 = { style: {"width":"100%"} }

import { ref, computed, watch } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseButton,
  BaseSelect,
  BaseDatePicker,
  BaseUpload,
  XrkMessage,
  BaseFormRef,
  BaseTextTitle,
  BaseTextContent,
  BaseCheckboxGroup,
  BaseCheckbox,
  useCreateModal,
  BaseCascader
} from 'xrk-components';
import { parkPageList } from '@data-source/park/apis';
import { uploadApi } from '@data-source/common/apis';
import { uploadLicense } from '../../data-source/apis';
import {
  INVOICE_TYPE,
  DECLARE_METHOD,
  TAX_ASSESSMENT_METHOD,
  INDIVIDUAL_TYPE
} from '../../constants';
import {
  AddIndividualParams,
  IndividualInfoDetailData
} from '../../data-source/types';
import AddCategoryDialog from './add-category-dialog.vue';
import { useDateFormat } from '@vueuse/core';
import { areaList } from '@data-source/common/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'license',
  props: /*#__PURE__*/_mergeModels({
    remove: {},
    type: { default: 'detail' },
    columnCount: { default: 4 }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const NOW = Date.now();
const _INDIVIDUAL_TYPE = [INDIVIDUAL_TYPE[3]];

const props = __props;

const isDetail = props.type === 'detail';

const formData = _useModel<IndividualInfoDetailData | AddIndividualParams>(__props, "modelValue");
const ruleFormRef = ref<BaseFormRef>();
const areaOptions = ref([]); // 选项
const areaModel = ref([]); // 绑定值
// 选择后的id+name集合
const areaVal = ref({
  provinceId: null,
  cityId: null,
  districtId: null,
  provinceName: null,
  cityName: null,
  districtName: null
});
const areaCascaderRef = ref(null);

// 详情中，可编辑且可补充的
const disabled = computed(() => {
  if (!isDetail) return false; // 非详情可编辑
  // 查看详情，平台审核后可补充操作
  if ([21].includes(+(formData.value as IndividualInfoDetailData)?.auditStatus))
    return false;
  return true;
});
// 详情中，终审通过后可保存操作的
const editDisabled = computed(() => {
  const auditStatus = +(formData.value as IndividualInfoDetailData)
    ?.auditStatus;
  if (!isDetail) return false; // 非详情可编辑
  if ([21, 22].includes(auditStatus)) return false; // 终审中与通过可编辑
  return true;
});
const showGt2Add = computed(() => {
  // !isDetail &&
  return formData.value.individualType == 2;
});

/* registerAt单独行内处理 */
const rules = {
  businessParkId: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],
  operator: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],
  phone: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],
  individualName: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],
  entpCertNo: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],

  _fileList: [
    {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (!value.length) {
          callback(new Error('请上传'));
        }
        callback();
      },
      trigger: 'change'
    }
  ],
  taxAssessmentMethod: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ],
  declareMethod: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ],
  _invoiceType: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ],
  _expira: [
    {
      required: true,
      message: '请选择',
      trigger: 'change',
      validator: (rule: any, value: any, callback: any) => {
        if (!formData.value.isPermanent && !value.length) {
          callback(new Error('请选择'));
        }
        callback();
      }
    }
  ],
  individualType: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ],
  invoiceItemIdList: [
    {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (!value.length) {
          callback(new Error('请选择'));
        }
        callback();
      },
      trigger: 'change'
    }
  ],
  districtId: [
    {
      required: true,
      message: '请选择',
      trigger: 'change'
    }
  ],
  businessScope: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ],
  businessAddress: [
    {
      required: true,
      message: '请填写',
      trigger: 'change'
    }
  ]
};

watch(
  () => formData.value,
  v => {
    const { provinceId, cityId, districtId } = v;
    if (provinceId && cityId && districtId) {
      areaModel.value = [provinceId, cityId, districtId];
    }
  },
  {
    once: true
  }
);

const disabledDate = date => {
  return date.getTime() >= NOW;
};
const parkRemoteMethod = async val => {
  return parkPageList({
    businessParkName: val,
    pageSize: 200,
    enable: 1 // 筛选启用的数据
  });
};
const getAreaList = async () => {
  const { data } = await areaList();
  areaOptions.value = data;
};

const onChangeRegisterAt = () => {
  /* 单独添加，联动无值的服务有效期 
     详情中不在此处处理
  */
  if (props.type === 'add' && !formData.value._expira.length) {
    formData.value._expira = [
      formData.value.registerAt,
      useDateFormat(
        new Date(
          new Date(formData.value.registerAt).getTime() +
            (365 - 1) * 24 * 60 * 60 * 1000
        ),
        'YYYY-MM-DD'
      ).value
    ];
  }
};
const onChangePark = (value, [park]) => {
  (formData.value as AddIndividualParams).parkType = park.parkType;
};
const onEntpCertPicChange = async file => {
  await ruleFormRef.value.validateField('_fileList');

  // 营业执照图片上传完成后识别信息
  if (file?.response?.data?.fileUrl) {
    try {
      const { data } = await uploadLicense({
        url: file.response.data.fileUrl
      });
      // 识别成功则填充相关信息
      if (data) {
        formData.value.individualName = data.individualName || '';
        formData.value.entpCertNo = data.entpCertNo || '';
        formData.value.registerAt = data.registerAt || '';
        formData.value.businessScope = data.businessScope || '';
        formData.value.businessAddress = data.businessAddress || '';
        XrkMessage.success('营业执照识别成功');
      }
    } catch (error) {
      console.error('营业执照识别失败:', error);
    }
  }
};
const onInvoiceItemRemove = index => {
  formData.value.invoiceItemIdList.splice(index, 1);
};
const onInvoiceItemAdd = () => {
  useCreateModal(AddCategoryDialog, {
    invoiceItemIdList: formData.value.invoiceItemIdList,
    onSuccess: payload => {
      formData.value.invoiceItemIdList.push(payload);
      ruleFormRef.value.validateField('invoiceItemIdList');
    }
  });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
const onChangeIndividualType = v => {
  // 客户个体默认服务有效期为长期，如果没有选择时间的话
  if (v === 2 && !formData.value._expira.length) {
    formData.value.isPermanent = 1;
  }
};
const onChangeArea = () => {
  const [nodes] = areaCascaderRef.value.getCheckedNodes();
  const { pathLabels, pathValues } = nodes;
  areaVal.value.provinceId = pathValues[0];
  areaVal.value.cityId = pathValues[1];
  areaVal.value.districtId = pathValues[2];
  areaVal.value.provinceName = pathLabels[0];
  areaVal.value.cityName = pathLabels[1];
  areaVal.value.districtName = pathLabels[2];
  Object.assign(formData.value, areaVal.value);
};
const onChangePermanent = val => {
  if (val) {
    formData.value._expira = [];
  }
};

getAreaList();

__expose({
  validate: () => {
    return ruleFormRef.value.validate();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isDetail
      ? (_openBlock(), _createBlock(_unref(BaseTextTitle), { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("个体户营业执照相关信息")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "label-position": "top",
          model: formData.value,
          rules: rules,
          "column-count": _ctx.columnCount
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "所属园区",
              prop: "businessParkId"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  style: {"width":"100%"},
                  placeholder: "请选择园区",
                  "label-key": "businessParkName",
                  "value-key": "id",
                  filterUseRemote: true,
                  init: true,
                  disabled: disabled.value,
                  remoteSelected: [
            {
              id: formData.value.businessParkId,
              businessParkName: formData.value.businessParkName
            }
          ],
                  remoteMethod: parkRemoteMethod,
                  modelValue: formData.value.businessParkId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.businessParkId) = $event)),
                  onChange: onChangePark
                }, null, 8, ["disabled", "remoteSelected", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "经营者",
              prop: "operator"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入经营者名称",
                  "show-word-limit": "",
                  maxlength: "50",
                  modelValue: formData.value.operator,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.operator) = $event)),
                  disabled: disabled.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "手机号",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入登录手机号",
                  type: "tel",
                  "show-word-limit": "",
                  maxlength: "11",
                  modelValue: formData.value.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event)),
                  disabled: disabled.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "个体户名称",
              prop: "individualName"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入个体户名称",
                  "show-word-limit": "",
                  maxlength: "50",
                  modelValue: formData.value.individualName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.individualName) = $event)),
                  disabled: disabled.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "统一社会信用代码",
              prop: "entpCertNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入对应的证件码",
                  "show-word-limit": "",
                  maxlength: "18",
                  modelValue: formData.value.entpCertNo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.entpCertNo) = $event)),
                  disabled: disabled.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "注册日期",
              prop: "registerAt",
              rules: [
          {
            required: disabled.value && formData.value.individualType === 2 ? false : true, // 客户个体类型查看详情不校验
            message: '请选择',
            trigger: 'change'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatePicker), {
                  style: {"width":"100%"},
                  placeholder: "请选择",
                  type: "date",
                  "validate-event": "",
                  modelValue: formData.value.registerAt,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.registerAt) = $event)),
                  disabled: disabled.value,
                  disabledDate: disabledDate,
                  onChange: onChangeRegisterAt
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (_ctx.columnCount == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            (_ctx.columnCount == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseFormItem), {
              label: "营业执照",
              prop: "_fileList"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  style: {"width":"100%"},
                  listType: "picture-card",
                  tipText: "支持上传jpg/png文件，且不超过50MB",
                  fileList: formData.value._fileList,
                  "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((formData.value._fileList) = $event)),
                  disabled: disabled.value,
                  "auto-upload": true,
                  multiple: false,
                  "http-request": _unref(uploadApi),
                  showFileList: true,
                  limit: 1,
                  limitSize: 50,
                  onError: onError,
                  accept: ['.jpg', '.png', '.jpeg', '.JPG', '.PNG', '.JPEG'],
                  onChange: onEntpCertPicChange
                }, null, 8, ["fileList", "disabled", "http-request"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "经营范围",
              prop: "businessScope"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请填写经营范围",
                  type: "textarea",
                  maxlength: "1000",
                  "show-word-limit": true,
                  rows: 9,
                  disabled: disabled.value,
                  modelValue: formData.value.businessScope,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.businessScope) = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "经营场所",
              prop: "businessAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请填写经营场所",
                  type: "textarea",
                  maxlength: "1000",
                  "show-word-limit": true,
                  rows: 9,
                  disabled: disabled.value,
                  modelValue: formData.value.businessAddress,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.businessAddress) = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            (_ctx.columnCount == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseFormItem), {
              label: "征收方式",
              prop: "taxAssessmentMethod"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  style: {"width":"100%"},
                  placeholder: "请选择征收方式",
                  modelValue: formData.value.taxAssessmentMethod,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.taxAssessmentMethod) = $event)),
                  options: _unref(TAX_ASSESSMENT_METHOD),
                  disabled: editDisabled.value
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "申报周期",
              prop: "declareMethod"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  style: {"width":"100%"},
                  placeholder: "请选择申报周期",
                  modelValue: formData.value.declareMethod,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.declareMethod) = $event)),
                  options: _unref(DECLARE_METHOD),
                  disabled: editDisabled.value
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "发票类型",
              prop: "_invoiceType"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseCheckboxGroup), {
                  modelValue: formData.value._invoiceType,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value._invoiceType) = $event)),
                  disabled: editDisabled.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(INVOICE_TYPE)[1], _unref(INVOICE_TYPE)[2]], (item) => {
                      return (_openBlock(), _createBlock(_unref(BaseCheckbox), {
                        key: item.value,
                        value: item.value,
                        label: item.label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (!isDetail)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 3,
                  label: "服务有效期",
                  prop: "_expira"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(BaseDatePicker), {
                          style: {"width":"100%"},
                          type: "daterange",
                          startPlaceholder: "开始时间",
                          endPlaceholder: "结束时间",
                          "validate-event": "",
                          disabled: disabled.value || !!formData.value.isPermanent,
                          modelValue: formData.value._expira,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value._expira) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _createVNode(_unref(BaseCheckbox), {
                        "true-value": 1,
                        "false-value": 0,
                        modelValue: formData.value.isPermanent,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.isPermanent) = $event)),
                        onChange: onChangePermanent
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 长期 ")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseFormItem), {
              label: "个体户类别",
              prop: "individualType"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  style: {"width":"100%"},
                  placeholder: "请选择个体户类别",
                  options: _INDIVIDUAL_TYPE,
                  disabled: disabled.value,
                  modelValue: formData.value.individualType,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.individualType) = $event)),
                  onChange: onChangeIndividualType
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            (showGt2Add.value)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 4,
                  label: "个体地址",
                  prop: "districtId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseCascader), {
                      style: {"width":"100%"},
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择证照地址",
                      ref_key: "areaCascaderRef",
                      ref: areaCascaderRef,
                      options: areaOptions.value,
                      props: {
            value: 'id',
            label: 'name',
            children: 'children'
          },
                      disabled: disabled.value,
                      modelValue: areaModel.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((areaModel).value = $event)),
                      onChange: onChangeArea
                    }, null, 8, ["options", "disabled", "modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseFormItem), {
              style: {
          'grid-column-start': 1,
          'grid-column-end': 4,
          'margin-bottom': '20px'
        },
              label: "开票类目",
              prop: "invoiceItemIdList"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.invoiceItemIdList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: {"width":"100%","margin-bottom":"10px","display":"flex","align-items":"center","justify-content":"space-between"}
                    }, [
                      _createVNode(_unref(BaseInput), {
                        style: {"flex":"1","margin-right":"10px"},
                        placeholder: "请选择",
                        disabled: "",
                        modelValue: item.label,
                        "onUpdate:modelValue": ($event: any) => ((item.label) = $event)
                      }, {
                        prepend: _withCtx(() => [
                          _createTextVNode("一级类目")
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_unref(BaseInput), {
                        style: {"flex":"1","margin-right":"10px"},
                        placeholder: "请选择",
                        disabled: "",
                        modelValue: item.subItemName,
                        "onUpdate:modelValue": ($event: any) => ((item.subItemName) = $event)
                      }, {
                        prepend: _withCtx(() => [
                          _createTextVNode("二级类目")
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_unref(BaseButton), {
                        type: "text",
                        onClick: ($event: any) => (onInvoiceItemRemove(index)),
                        disabled: editDisabled.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]))
                  }), 128)),
                  _createVNode(_unref(BaseButton), {
                    type: "text",
                    onClick: onInvoiceItemAdd,
                    disabled: editDisabled.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 添加 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "column-count"])
      ]),
      _: 1
    })
  ], 64))
}
}

})